import React, { useEffect } from 'react';
import './App.css';
import db from './firebase';
import { collection, doc, getDoc, getDocs, query, serverTimestamp, setDoc, updateDoc, addDoc } from "firebase/firestore";
import { getAuth, createUserWithEmailAndPassword, signInWithEmailAndPassword, onAuthStateChanged, signOut } from "firebase/auth";

function Login(props){
  const [email3, setEmail3] = React.useState("");
  const [pass4, setPassword4] = React.useState("");

  const loginWT = ()=>{
    maskOpen();
    if(email3 === '' || pass4 === ''){
      const checkRed = document.getElementById('checkRed');
      checkRed.innerHTML = "※E-mailもしくはパスワードが違います。"
      maskClose();
      return
    }
    const auth = getAuth();
    signInWithEmailAndPassword(auth, email3, pass4)
    .then((userCredential) => {
      const user = userCredential.user;
      props.loginSuccess('PetName',5,user.uid)
    })
    .catch((error) => {
      const errorCode = error.code;
      const errorMessage = error.message;
      console.log(errorCode);
      console.log(errorMessage);
      const checkRed = document.getElementById('checkRed');
      checkRed.innerHTML = "※E-mailもしくはパスワードが違います。"
      maskClose();
    });
  }
  const pressEnterLogin = (e)=>{
    if (e.key === 'Enter') {
      e.preventDefault();
      loginWT();
    }
  }

  return(
    <div className='setDateMask'>
      <div>
        <p className='formTopQ'>ログイン情報を入力してください。</p>
        <p className='borderBlack'></p>
        <p className='inputLabel'>メールアドレス</p>
        <input type="email" className="inputBook" placeholder="E-mail" value={email3} onChange={(e)=> setEmail3(e.target.value)}  maxLength="40" autoComplete="email" name="email"/>
        <p className='inputLabel'>パスワード</p>
        <input type="password" className="inputBook" placeholder="Password" value={pass4} onChange={(e)=> setPassword4(e.target.value)} onKeyPress={(e)=>pressEnterLogin(e)} />
        <button className='loginBtn' onClick={()=>loginWT()}>ログイン</button>
        <p id='checkRed'></p>
        <button className='backBtn' onClick={()=>props.backPage('PetName',5)}>前に戻る</button>
      </div>
    </div>
  );
}
function BookDone(props){
  const [email3, setEmail3] = React.useState(props.state.email);
  const [pass4, setPassword4] = React.useState("");
  const [pass8, setPassword8] = React.useState("");
  const [signNow, setSignNow] = React.useState(false);

  const signInWT = ()=>{
    if(email3 === ''){
      let errRegister = document.getElementById('errRegister');
      errRegister.innerHTML = 'メールアドレスを入力してください。'
      return
    }else if(pass4 !== pass8){
      let errRegister = document.getElementById('errRegister');
      errRegister.innerHTML = 'パスワードが一致しません。'
      return
    }else if(pass4.length < 8){
      let errRegister = document.getElementById('errRegister');
      errRegister.innerHTML = 'パスワードは8文字以上です。';
      return
    }

    maskOpen();

    const auth = getAuth();
    createUserWithEmailAndPassword(auth, email3, pass4)
      .then((userCredential) => {
        // Signed in 
        const user = userCredential.user;
        // console.log(user);

        setConfirm(user.uid)
      })
      .catch((error) => {
        const errorCode = error.code;
        const errorMessage = error.message;
        console.log(errorCode);
        console.log(errorMessage);
        const pp = document.getElementById('errRegister');
        pp.innerHTML = "登録できませんでした。"
        if(errorCode === "auth/email-already-in-use"){
          pp.innerHTML = "このメールアドレスはすでに使用されています。"
        }else if(errorCode === "auth/invalid-email"){
          pp.innerHTML = "メールアドレスが無効です。"
        }
        maskClose();
      });
  }
  const setConfirm = async(userId)=>{

    try{
      const docRef2 = doc(db, "ahCustomerListsWT", props.propsState.id, "ahCustomerListsWT2", userId);
      let thisTime = [{
        history: props.state.history,
        details: props.state.details,
        detailsTime: props.state.detailsTime,
        teacher: props.state.teacher,
        teacherName: props.state.teacherName,
        teacherFixed: props.state.teacherFixed,
        bookDate: props.state.bookDate,
        bookTime: props.state.bookTime,
        petName: props.state.petName,
        petType: props.state.petType,
        name: props.state.name,
        cardNum: props.state.cardNum,
        telNum: props.state.telNum,
        email: props.state.email,
        other: props.state.other,
        state: '予約',
        from: 'WEB',
        bookId: docRef2.id,
        customerId: userId
        // createdAt: serverTimestamp()
      }]
      await setDoc(docRef2,{
        name: props.state.name,
        name2: props.state.name2,
        cardNum: props.state.cardNum,
        telNum: props.state.telNum,
        email: props.state.email,
        petName: props.state.petName,
        petName2: props.state.petName2,
        petType: props.state.petType,
        customerId: userId,
        createdAt: serverTimestamp(),
        bookHistory: thisTime
      });
      console.log('Sign in complete');
      const pp = document.getElementById('registerd2');
      pp.innerHTML = "登録が完了しました。"
      setSignNow(true);
      maskClose();
    }catch(e){
      console.log(e);
      maskClose();
    }
  }
  const signInput =()=>{
    return (
      <div>
         <p className='borderBlack'></p>
          <p className="formTopQ">マイページ登録</p>
          <p>今回の予約情報をマイページ登録しますか？</p>
          <p>※次回からの入力が省略できます。</p>

          <div className='confirmPage'>
            <p className="blueLeft">飼い主様情報</p>
            <p>名前：{props.state.name + ' ' + props.state.name2}</p>
            <p>電話番号：{props.state.telNum}</p>
            <p>メールアドレス：{props.state.email}</p>

            <p className="blueLeft">ペット情報</p>
            <p>名前：{props.state.petName + ' ' + props.state.petName2}</p>
            <p>種類：{props.state.petType}</p>
            <p>診察券番号：{props.state.cardNum}</p>
          </div>

          {props.state.email === '' ?
          <div>
            <p className='inputLabel'>メールアドレス<span className='redField'>必須</span></p>
            <input type="text" placeholder="abc@abc.com" className="inputBook" value={email3} onChange={(e)=> setEmail3(e.target.value)} maxLength="30"/> 
          </div> : ''}

          <p className='inputLabel'>パスワード設定<span className='redField'>必須</span><br /><span className='register88'>（英数8文字以上）</span></p>
          <input type="password" placeholder="password" className="inputBook" value={pass4} onChange={(e)=> setPassword4(e.target.value)} maxLength="15"/>
          <p className='inputLabel'>パスワード設定（確認）<span className='redField'>必須</span></p>
          <input type="password" placeholder="password" className="inputBook" value={pass8} onChange={(e)=> setPassword8(e.target.value)} maxLength="15"/>
          
          <button className='nextBtn2' onClick={()=>signInWT()}>マイページに登録する</button>
          <p id='errRegister'></p>
      </div>
    )
  }

  return(
    <div>
      <p className="formTopQ">予約が完了しました。</p>
      <p id='registerd2' className="pSendMail">ご利用ありがとうございました。<br /><br />入力頂いたメールアドレスに予約内容をお送りしております。<br />それでは当日はお気をつけてお越しくださいませ。</p>
     
      {/* {props.state.login === false && signNow === false ? signInput() : ''} */}
    </div>
  );
}
function Confirm(props){
  // const [other, setOther] = React.useState('');

  let bookDate3 = (props.state.bookDate).slice(0,4) + '年' + (props.state.bookDate).slice(4,6) + '月' + (props.state.bookDate).slice(-2) + '日';
  return (
    <div className='setDateMask'>
      <div>
        <p className="formTopQ">入力内容の確認</p>
        <p className='borderBlack'></p>

        <div className='confirmPage'>
          <p className='blueLeft'>予約日時</p>
          <p>{bookDate3}　{props.state.bookTime}</p>
          <p className='blueLeft'>予約内容</p>
          <p>獣医師：{props.state.teacherFixed === 'フリー' ? '指名なし' : props.state.teacherName}</p>
          <p>診察内容：{props.state.history + ' ' + props.state.details}</p>
          <p>備考：{props.state.other}</p>

          <p className="blueLeft">受診するペット</p>
          <p>名前：{props.state.petName + ' ' + props.state.petName2}</p>
          <p>種類：{props.state.petType}</p>
          <p>診察券番号：{props.state.cardNum}</p>

          <p className="blueLeft">飼い主様情報</p>
          <p>名前：{props.state.name + ' ' + props.state.name2}</p>
          <p>電話番号：{props.state.telNum}</p>
          <p>メールアドレス：{props.state.email}</p>
        </div>
        <button className='nextBtn2' onClick={()=>props.setConfirm()}>この内容で予約する</button>
        <button className='backBtn' onClick={()=>props.backPage('GuestName',5)}>前に戻る</button>
      </div>
    </div>
  );
}
function GuestName(props){

  let family = props.state.login === false ? props.state.petName : props.state.name;
  const [guestName, setGuestName] = React.useState(family);
  const [guestName2, setGuestName2] = React.useState(props.state.name2);
  const [telNum, setTelNum] = React.useState(props.state.telNum);
  const [email, setEmail] = React.useState(props.state.email);
  const [line, setLine] = React.useState(false);

  const checkLinePush = (e)=>{
    setLine(e.target.checked);
  }
  const blankCheck =()=>{
    let checkRed = document.getElementById('checkRed');
    if(guestName === '' || guestName2 === ''){
      checkRed.innerHTML = '※お名前を入力してください。'
      return
    }else if(telNum === ''){
      checkRed.innerHTML = '※電話番号を入力してください。'
      return
    }
    props.setGuestName(guestName,guestName2,telNum,email,line)
  }

  return (
    <div className='setDateMask'>
      <div>
        <p className="formTopQ">飼い主様の情報を入力ください</p>

        <p className='borderBlack'></p>

        <p className='inputLabel'>お名前<span className='redField'>必須</span></p>
        <input type="text" placeholder="姓" className="inputBook2" value={guestName} onChange={(e)=> setGuestName(e.target.value)} maxLength="12" autoComplete="family-name" name="name"/>
        <input type="text" placeholder="名" className="inputBook2" value={guestName2} onChange={(e)=> setGuestName2(e.target.value)} maxLength="12" autoComplete="given-name" name="name"/>
        <p className='inputLabel'>電話番号<span className='redField'>必須</span></p>
        <input type="tel" placeholder="XXX-XXXX-XXXX" className="inputBook" value={telNum} onChange={(e)=> setTelNum(e.target.value)} maxLength="15" autoComplete="tel-national" name="tel"/> 
        <p className='pBlue'>予約結果の通知方法</p>
        <p className='inputLabel'>メールアドレス</p>
        <input type="email" placeholder="wan-touch@sample.com" className="inputBook" value={email} onChange={(e)=> setEmail(e.target.value)} maxLength="40" autoComplete="email" name="email"/> 
        {/* <p className='inputLabel'>LINEでの通知</p>
        <div className='checkCardDiv'>
          <input type="checkbox" id='linepush' onChange={(e)=>checkLinePush(e)} checked={line} />
          <label htmlFor='linepush'>LINEでの通知を希望</label>
        </div> */}
        
        <button className='nextBtn2' onClick={()=> blankCheck()}>→つぎ　入力内容の確認</button>
        <p id='checkRed'></p>
        <button className='backBtn' onClick={()=>props.backPage('PetName',5)}>前に戻る</button>
      </div>
    </div>
  );
}
function PetName(props){
  const [petName, setPetName] = React.useState(props.state.petName);
  const [petName2, setPetName2] = React.useState(props.state.petName2);
  const [petType, setPetType] = React.useState(props.state.petType);
  const [cardNum, setCardNum] = React.useState(props.state.cardNum);
  const [other, setOther] = React.useState(props.state.other);
  const [noCard, setNoCard] = React.useState(false);

  const setPetTypeBtn = ()=>{
    let ary = [];
    for(let i = 0; i < props.propsState.allField.petType.length; i++){
      let petType = props.propsState.allField.petType[i];
      ary.push(
        <option value={petType} key={petType + i}>{petType}</option>
      )
    }
    return ary;
  }
  const calcTextAreaHeight = (value)=>{
    var rowsNum = 5
    if(value.split('\n').length >3){
      rowsNum = value.split('\n').length;
    }
    return rowsNum
  }
  const checkNoCard = (e)=>{
    setNoCard(e.target.checked);

    const cardInput = document.getElementById('cardInput')
    if(e.target.checked){
      setCardNum('');
      cardInput.disabled = true;
    }else{
      cardInput.disabled = false;
    }
  }
  const blankCheck =()=>{
    let checkRed = document.getElementById('checkRed');
    if(petName === '' || petName2 === ''){
      checkRed.innerHTML = '※お名前を入力してください。'
      return
    }else if(cardNum === '' && noCard === false){
      checkRed.innerHTML = '※診察券番号を入力してください。'
      return
    }else if(petType === ''){
      checkRed.innerHTML = '※ペットの種類を選択してください。';
      return
    }else if(cardNum !== '' && noCard === false){
      let pattern = /^[A-Za-z0-9]*$/;
      if (!pattern.test(cardNum)) {
        checkRed.innerHTML = '※診察券番号を半角英数字で入力してください。';
        return
      }
    }
    props.setPetName(petName,petName2,petType,cardNum,other)
  }
  return (
    <div className='setDateMask'>
      <div>
        <p className="formTopQ">ペットの情報を入力ください</p>

        {/* {props.state.login === false ? 
          <div className='loginDiv'>
            <p className='fzM'>登録済みの方は、こちら</p>
            <button className='loginBtn' onClick={()=>props.backPage('Login',6)}>ログイン</button>
          </div> : ''} */}
        
        <p className='inputLabel'>ペットの名前<span className='redField'>必須</span></p>
        <input type="text" placeholder="姓" className="inputBook2" value={petName} onChange={(e)=> setPetName(e.target.value)} maxLength="12" autoComplete="family-name" name="name"/>
        <input type="text" placeholder="名" className="inputBook2" value={petName2} onChange={(e)=> setPetName2(e.target.value)} maxLength="12" autoComplete="given-name" name="name"/> 

        <p className='inputLabel'>診察券番号<span className='redField'>必須</span></p>
        <input type="url" placeholder="XXXXXXXX" className="inputBook" value={cardNum} onChange={(e)=> setCardNum(e.target.value)} maxLength="20" id='cardInput' pattern="^[a-zA-Z0-9]+$"/> 
        <div className='checkCardDiv'>
          <input type="checkbox" id='noCard' onChange={(e)=>checkNoCard(e)} checked={noCard} />
          <label htmlFor='noCard'>診察券番号がわからない</label>
        </div>
      
        <p className='inputLabel'>ペット種類<span className='redField'>必須</span></p>
        <div className="selectBookOut">
          <select className="selectBook" name="petType" onChange={(e) => setPetType(e.target.value)} defaultValue={petType}>
            <option value='' key='petBlank'>選択してください</option>
            {setPetTypeBtn()}
          </select>
        </div>
        <p className='inputLabel'>備考（症状やその他相談内容など）</p>
        <textarea className="otherArea" rows={calcTextAreaHeight(other)} onChange={(e)=> setOther(e.target.value)} value={other}></textarea>
      
        <button className='nextBtn2' onClick={()=> blankCheck()}>→つぎ　飼い主様情報を入力する</button>
        <p id='checkRed'></p>
        <button className='backBtn' onClick={()=>props.backSetDate2('SetDate2',props.state.btnNum -1)}>前に戻る</button>
      </div>
    </div>
    
  );
}
function SetDate2(props){
  const [set, setSet] = React.useState(<div className='setDate2Loading'>読み込み中…</div>);
  const monSun = props.state.bookDayMon;
  const selectTeacher = props.state.teacher
  const selectDate = props.state.bookDate

  let teacherAry = [...props.propsState.allField.teacher2]
  for(let i = 0; i < teacherAry.length; i++){
    if(teacherAry[i]['detailsNG'].includes(props.state.details)){
      teacherAry.splice(i,1)
    }
  }
  const teacher7 = teacherAry
  const index = teacher7.findIndex(tc => tc.id === selectTeacher);

  const whoTime2 = [];
  if(selectTeacher === 'free'){
     whoTime2.push(props.propsState.allField[monSun]);
  }else{
    whoTime2.push(props.propsState.allField[monSun]);
    // whoTime2.push(teacher7[index][monSun]);
  }
  const whoTime = whoTime2[0];

  const todayCheck = (selectDay)=>{
    let jpTime = new Date(Date.now() + ((new Date().getTimezoneOffset() + (9 * 60)) * 60 * 1000));
    var year = jpTime.getFullYear();
    var month = jpTime.getMonth();
    var date = jpTime.getDate();
    let aaa = year + (('0' + String(month + 1)).slice(-2)) + (('0' + String(date)).slice(-2));
    let result = aaa === selectDay ? true : false;
    return result
  }
  const todayOrNot = todayCheck(selectDate);

  const setOpenTime = (whoTime)=>{
    let start = whoTime.open1;
    let end = whoTime.close1;
    
    let today = new Date();
    let startTime = today.getFullYear() + '/' + (today.getMonth() +1) + '/' + today.getDate() + ' ' + start;
    let today2 = new Date(startTime);
    let endTime = today.getFullYear() + '/' + (today.getMonth() +1) + '/' + today.getDate() + ' ' + end;
    let startTime2 = new Date(startTime);
    let endTime2 = new Date(endTime);
    let rowTimes = (endTime2 - startTime2)/1800000;
    let ary = [];

    ary.push(('0' + today2.getHours()).slice(-2) + ':' + ('0' + today2.getMinutes()).slice(-2)); 
    for(var i = 0; i < rowTimes; i++){
      today2.setMinutes(today2.getMinutes() + 30);
      let www = ('0' + today2.getHours()).slice(-2) + ':' + ('0' + today2.getMinutes()).slice(-2);
      ary.push(www);
    }
    return ary;
  }
  const setOpenTime2 = (whoTime)=>{
    let start = whoTime.open2;
    let end = whoTime.close2;

    let today = new Date();
    let startTime = today.getFullYear() + '/' + (today.getMonth() +1) + '/' + today.getDate() + ' ' + start;
    let today2 = new Date(startTime);
    let endTime = today.getFullYear() + '/' + (today.getMonth() +1) + '/' + today.getDate() + ' ' + end;
    let startTime2 = new Date(startTime);
    let endTime2 = new Date(endTime);
    let rowTimes = (endTime2 - startTime2)/1800000;
    let ary = [];
    ary.push(('0' + today2.getHours()).slice(-2) + ':' + ('0' + today2.getMinutes()).slice(-2));
    for(var i = 0; i < rowTimes; i++){
      today2.setMinutes(today2.getMinutes() + 30);
      let www = ('0' + today2.getHours()).slice(-2) + ':' + ('0' + today2.getMinutes()).slice(-2);
      ary.push(www);
    }
    return ary;
  }
  const setOpenTime3 = (whoTime)=>{
    // let jpTime = new Date()
    let jpTime = new Date(Date.now() + ((new Date().getTimezoneOffset() + (9 * 60)) * 60 * 1000));
    let hour = jpTime.getHours();
    let min = ('0' + jpTime.getMinutes()).slice(-2);
    let nowTime = hour + ':' + min;

    let start = whoTime.open1;
    let end = nowTime;
    
    let today = new Date();
    let startTime = today.getFullYear() + '/' + (today.getMonth() +1) + '/' + today.getDate() + ' ' + start;
    let today2 = new Date(startTime);
    let endTime = today.getFullYear() + '/' + (today.getMonth() +1) + '/' + today.getDate() + ' ' + end;
    let startTime2 = new Date(startTime);
    let endTime2 = new Date(endTime);
    let rowTimes = (endTime2 - startTime2)/1800000;
    let ary = [];

    ary.push(('0' + today2.getHours()).slice(-2) + ':' + ('0' + today2.getMinutes()).slice(-2)); 
    for(var i = 0; i < rowTimes; i++){
      today2.setMinutes(today2.getMinutes() + 30);
      let www = ('0' + today2.getHours()).slice(-2) + ':' + ('0' + today2.getMinutes()).slice(-2);
      ary.push(www);
    }
    return ary;
  }

  let ary2 = setOpenTime(whoTime);
  let ary3 = whoTime.times === 2 ? setOpenTime2(whoTime) : [];
  let ary88 = [];
  if(todayOrNot){
    ary88 = setOpenTime3(whoTime);
    ary88.pop();
  }

  const getData = ()=>{
    let row = [];
    let ary4 = {};
    // try{
      let lists = props.state.bookList[selectDate]

      if(selectTeacher === 'free'){
        let ay = []
        if(lists !== undefined){
          Object.keys(lists).forEach((element) => {
            if(lists[element].state !== "キャンセル"){
              ay.push(lists[element]);
            }
          });
        }
        
        let ary8 = [];
        for (let i = 0; i < teacher7.length; i++){
          // docSnapDate 予約全て入ってる
          let EachTeacherAry = ay.filter(function(doc) {
            return doc.teacher === teacher7[i]['id'];
          });

          let ary6 = {};
          EachTeacherAry.forEach((doc) => {
            let bt = doc.bookTime;
            if(ary6[bt]){
              ary6[bt] += doc.detailsTime;
            }else{
              ary6[bt] = doc.detailsTime;
            }
          });
          ary8.push(ary6);
        }

        // ary8 先生一人当たりの予約されてる時間が配列で並んでる
        let leftTime2 = []
        for (let i = 0; i < ary8.length; i++){
          let leftTime0 = []
          for (let m = 0; m < ary2.length -1; m++){
            leftTime0.push(ary8[i][ary2[m]] === undefined ? 30 : 30 - ary8[i][ary2[m]]);
          }
          leftTime2.push(leftTime0);
        }

        // leftTime 先生一人当たりの空き時間が配列で並んでる
        // ary2　病院の営業時間
        let teacherTimeAry = []
        teacher7.forEach((tc) => {
          let tcTimeAry = setOpenTime(tc[monSun]);
          tcTimeAry.pop();
          teacherTimeAry.push(tcTimeAry)
        })

        for (let i = 0; i < ary2.length -1; i++){
          let span2 = ''
          let past = false;
          if(todayOrNot){
            if(ary88.includes(ary2[i])){
              past = true
            }
          }

          if(past){
            span2 = <div className="timeSection full">
                      <span>{ary2[i]} - {ary2[i + 1]}</span>
                      <span className='timeSectionSign'>-</span>
                    </div>
          }else{

            for (let k = 0; k < leftTime2.length; k++){
              if(leftTime2[k][i] >= props.state.detailsTime && teacherTimeAry[k].includes(ary2[i])){
  
                span2 = <div className="timeSection" onClick={()=>props.setDate2(ary2[i],teacher7[k])}>
                          <span>{ary2[i]} - {ary2[i + 1]}</span>
                          <span className='timeSectionSign'>〇</span>
                        </div>
  
                break
              }else{
                span2 = <div className="timeSection full">
                          <span>{ary2[i]} - {ary2[i + 1]}</span>
                          <span className='timeSectionSign'>-</span>
                        </div>
              }
            }
          }
          // for (let k = 0; k < leftTime2.length; k++){
          //   if(leftTime2[k][i] >= props.state.detailsTime && teacherTimeAry[k].includes(ary2[i])){

          //     span2 = <div className="timeSection" onClick={()=>props.setDate2(ary2[i],teacher7[k])}>
          //               <span>{ary2[i]} - {ary2[i + 1]}</span>
          //               <span className='timeSectionSign'>〇</span>
          //             </div>

          //     break
          //   }else{
          //     span2 = <div className="timeSection full">
          //               <span>{ary2[i]} - {ary2[i + 1]}</span>
          //               <span className='timeSectionSign'>-</span>
          //             </div>
          //   }
          // }
          row.push(
            <div key={i + '1'}>
                {span2}
            </div>
          )
        }

        row.push(<p key='setDatePP'><br /></p>);
        let leftTime3 = []
        for (let i = 0; i < ary8.length; i++){
          let leftTime0 = []
          for (let m = 0; m < ary3.length -1; m++){
            leftTime0.push(ary8[i][ary3[m]] === undefined ? 30 : 30 - ary8[i][ary3[m]]);
          }
          leftTime3.push(leftTime0);
        }
        // console.log(leftTime3);
        let teacherTimeAry3 = []
        teacher7.forEach((tc) => {
          if(tc[monSun].times === 2){
            let tcTimeAry = setOpenTime2(tc[monSun]);
            tcTimeAry.pop();
            teacherTimeAry3.push(tcTimeAry)
          }else{
            teacherTimeAry3.push(['off']);
          }
        })

        for (let i = 0; i < ary3.length -1; i++){
          let span2 = ''
          let past = false;
          if(todayOrNot){
            if(ary88.includes(ary3[i])){
              past = true
            }
          }

          if(past){
            span2 = <div className="timeSection full">
                      <span>{ary3[i]} - {ary3[i + 1]}</span>
                      <span className='timeSectionSign'>-</span>
                    </div>
          }else{

            for (let k = 0; k < leftTime3.length; k++){
              if(leftTime3[k][i] >= props.state.detailsTime && teacherTimeAry3[k].includes(ary3[i])){
                 span2 = <div className="timeSection" onClick={()=>props.setDate2(ary3[i],teacher7[k])}>
                          <span>{ary3[i]} - {ary3[i + 1]}</span>
                          <span className='timeSectionSign'>〇</span>
                        </div>
                break
              }else{
                span2 = <div className="timeSection full">
                          <span>{ary3[i]} - {ary3[i + 1]}</span>
                          <span className='timeSectionSign'>-</span>
                        </div>
              }
            }
          }
          // for (let k = 0; k < leftTime3.length; k++){
          //   if(leftTime3[k][i] >= props.state.detailsTime && teacherTimeAry3[k].includes(ary3[i])){
          //      span2 = <div className="timeSection" onClick={()=>props.setDate2(ary3[i],teacher7[k])}>
          //               <span>{ary3[i]} - {ary3[i + 1]}</span>
          //               <span className='timeSectionSign'>〇</span>
          //             </div>
          //     break
          //   }else{
          //     span2 = <div className="timeSection full">
          //               <span>{ary3[i]} - {ary3[i + 1]}</span>
          //               <span className='timeSectionSign'>-</span>
          //             </div>
          //   }
          // }
          row.push(
            <div key={i + '2'}>
                {span2}
            </div>
          )
        }

      }else{
        let ary44 = setOpenTime(teacher7[index][monSun]);
        let ary55 = teacher7[index][monSun].times === 2 ? setOpenTime2(teacher7[index][monSun]) : [];
        ary44.pop();
        if(ary55.length > 0){ary55.pop()}

        let ay = []
        if(lists !== undefined){
          Object.keys(lists).forEach((element) => {
            if(lists[element].state !== "キャンセル" && lists[element].teacher === selectTeacher){
              ay.push(lists[element]);
            }
          });

          ay.forEach((doc) => {
            let bt = doc.bookTime;
            if(ary4[bt]){
              ary4[bt] += doc.detailsTime;
            }else{
              ary4[bt] = doc.detailsTime;
            }
          });
        }

        for (let i = 0; i < ary2.length -1; i++){
          let leftTime = ary4[ary2[i]] === undefined ? 30 : 30 - ary4[ary2[i]];

          if(!ary44.includes(ary2[i])){
            leftTime = 0
          }

          let past = false;
          if(todayOrNot){
            if(ary88.includes(ary2[i])){
              past = true
            }
          }
          row.push(
            <div key={i + '1'}>
              {past ?
                <div className="timeSection full">
                  <span>{ary2[i]} - {ary2[i + 1]}</span>
                  <span className='timeSectionSign'>-</span>
                </div>
                :
                leftTime >= props.state.detailsTime ?
                <div className="timeSection" onClick={()=>props.setDate2(ary2[i],'notFree')}>
                  <span>{ary2[i]} - {ary2[i + 1]}</span>
                  <span className='timeSectionSign'>〇</span>
                </div>
                :
                <div className="timeSection full">
                  <span>{ary2[i]} - {ary2[i + 1]}</span>
                  <span className='timeSectionSign'>-</span>
                </div>
              }
              {/* {leftTime >= props.state.detailsTime ?
                <div className="timeSection" onClick={()=>props.setDate2(ary2[i],'notFree')}>
                  <span>{ary2[i]} - {ary2[i + 1]}</span>
                  <span className='timeSectionSign'>〇</span>
                </div>
                :
                <div className="timeSection full">
                  <span>{ary2[i]} - {ary2[i + 1]}</span>
                  <span className='timeSectionSign'>-</span>
                </div>
                } */}
            </div>
          )
        }

        row.push(<p key='setDatePP'><br /></p>);
        for (let i = 0; i < ary3.length -1; i++){
          let leftTime = ary4[ary3[i]] === undefined ? 30 : 30 - ary4[ary3[i]];

          if(!ary55.includes(ary3[i])){
            leftTime = 0
          }

          let past = false;
          if(todayOrNot){
            if(ary88.includes(ary3[i])){
              past = true
            }
          }

          row.push(
            <div key={i + '2'}>
              {past ?
                <div className="timeSection full">
                  <span>{ary3[i]} - {ary3[i + 1]}</span>
                  <span className='timeSectionSign'>-</span>
                </div>
                :
                leftTime >= props.state.detailsTime ?
                <div className="timeSection" onClick={()=>props.setDate2(ary3[i],'notFree')}>
                  <span>{ary3[i]} - {ary3[i + 1]}</span>
                  <span className='timeSectionSign'>〇</span>
                </div>
                :
                <div className="timeSection full">
                  <span>{ary3[i]} - {ary3[i + 1]}</span>
                  <span className='timeSectionSign'>-</span>
                </div>
              }
              {/* {leftTime >= props.state.detailsTime ?
                <div className="timeSection" onClick={()=>props.setDate2(ary3[i],'notFree')}>
                  <span>{ary3[i]} - {ary3[i + 1]}</span>
                  <span className='timeSectionSign'>〇</span>
                </div>
                :
                <div className="timeSection full">
                  <span>{ary3[i]} - {ary3[i + 1]}</span>
                  <span className='timeSectionSign'>-</span>
                </div>
                } */}
            </div>
          )
        }
      }
      setSet(row);
  }
  useEffect(() => {
    getData();
  }, [])
  
  return (
    <div className='setDateMask'>
      <div>
        <button className='closeBtn' onClick={()=>props.backPage('SetDate',props.state.btnNum)}>×</button>
        <p className="formTopQ3">受診時間を選択してください。</p>
        <p className='setDateDay'>{selectDate.slice(4,6)}月{selectDate.slice(-2)}日</p>
        <div className='bookFrame2'>
          {set}
        </div>
        <button className='backBtn' onClick={()=>props.backPage('SetDate',props.state.btnNum)}>前に戻る</button>
      </div>
    </div>
  );
}
function SetDate(props) {
  const week = ["日", "月", "火", "水", "木", "金", "土"];
  const today = new Date();
  let showDate = new Date(today.getFullYear(), today.getMonth(), 1);
  const [showDate3, setShowDate3] = React.useState(showDate);
  const [calender5, setCalender5] = React.useState();
  const acceptBook = props.propsState.allField.setting.acceptBook;
  let limitDay = new Date();
  limitDay.setDate(limitDay.getDate() + acceptBook);

  const tcList = props.propsState.allField.teacher2;

  function setDate3(bookDate,mon){
    props.setDate(bookDate,mon);
  }
  function prev(){
      showDate.setYear(showDate3.getFullYear());
      showDate.setMonth(showDate3.getMonth() - 1);
      let aaa = new Date(showDate);
      setShowDate3(aaa);
      showProcess(aaa);
  }
  function next(){
      showDate.setYear(showDate3.getFullYear());
      showDate.setMonth(showDate3.getMonth() + 1);
      let aaa = new Date(showDate);
      setShowDate3(aaa);
      showProcess(aaa);
  }
  async function getDataDayOnOff(bookMonth){
    let dayOnOffAry = {};
    try{
      const docRef2 = doc(db, "waitingList", props.propsState.id, bookMonth, 'specialDayOff');
      const docRef = await getDoc(docRef2);
      if(docRef.exists()){
        dayOnOffAry = docRef.data().dayOff;
      }
    }catch(e){
      console.log(e);
    }
    return dayOnOffAry;
  }
  async function showProcess(date) {
      maskOpen();
      var year = date.getFullYear();
      var month = date.getMonth();
      let calendar;

      let thisMonth = new Date();
      let thisMonth2 = thisMonth.getMonth();

      if(month !== thisMonth2){
        calendar = await createProcess(year, month, 'other');
      }else{
        calendar = await createProcess(year, month, 'thisMonth');
      }

      // let limitDayMonth = limitDay.getMonth();
      // if(limitDayMonth < 2){
      //   limitDayMonth += 12
      // }
      // if(month !== (limitDayMonth - 2)){
      //   calendar = await createProcess(year, month, 'other');
      // }else{
      //   calendar = await createProcess(year, month, 'thisMonth');
      // }

      setCalender5(calendar);
      maskClose();
  }
  const checkDayOffAry = (dayOnOffAry, bookDate)=>{
    let result = ''
    if(Object.keys(dayOnOffAry).length !== 0){

      if ('all' in dayOnOffAry){
        if(dayOnOffAry['all'].includes(bookDate)){
          result = 'all'

        }else{
          if(props.state.teacher in dayOnOffAry){
            if(dayOnOffAry[props.state.teacher].includes(bookDate)){
              result = 'tc'
            }else{
              result = 'none'
            }
          }else{
            result = 'none'
          }
        }
      }else{
        if(props.state.teacher in dayOnOffAry){
          if(dayOnOffAry[props.state.teacher].includes(bookDate)){
            result = 'tc'
          }else{
            result = 'none'
          }
        }else{
          result = 'none'
        }
      }
    }else{
      result = 'none'
    }
    return result
  }
  async function getDaysUsedTime(bookMonth){

    const docRef = query(collection(db, "waitingList", props.propsState.id, bookMonth));
    const docLists = await getDocs(docRef);
    
    let ary = {}
    let bookList2 = {};
    docLists.forEach((doc) => {
      let usedTime = 0
      let docId = doc.id;
      let bookList = doc.data().bookList;

      if(bookList !== undefined){
        Object.keys(bookList).forEach((element) => {

          if(props.state.teacher === 'free'){

            if(bookList[element].state !== 'キャンセル'){
              usedTime += bookList[element].detailsTime;
            }

          }else{

            if(bookList[element].state !== 'キャンセル' && bookList[element].teacher === props.state.teacher){
              usedTime += bookList[element].detailsTime;
            }
          }
        });
      }
      ary[docId] = usedTime;
      bookList2[docId] = bookList;
    });

    props.setBookList(bookList2);
    return ary;
  }
  function totalSpaceNum(){
    let weekAry2 = [];
    const weekAry = ["sun", "mon", "tue", "wed", "thu", "fri", "sat"];
    for(let k = 0; k < weekAry.length ; k++){
      let monTime = 0;

      if(props.state.teacher === 'free'){

        for(let i = 0; i < tcList.length; i++){
          if(!tcList[i][weekAry[k]].dayOff){
            monTime += tcList[i][weekAry[k]].tenTimes
          }
        }

      }else{
        
        for(let i = 0; i < tcList.length; i++){
          if(!tcList[i][weekAry[k]].dayOff && tcList[i].id === props.state.teacher){
            monTime += tcList[i][weekAry[k]].tenTimes
          }
        }
      }
      weekAry2.push(monTime /10);
    }
    // console.log(weekAry2)
    return weekAry2
  }
  // カレンダー作成
  async function createProcess(year, month, whichMonth) {
      let bookMonth = year + (('0' + String(month + 1)).slice(-2));
      let dayOnOffAry = await getDataDayOnOff(bookMonth);

      let weekTimesAry = totalSpaceNum();
      let daysUsedTime = await getDaysUsedTime(bookMonth)
      // console.log(weekTimesAry)
  
      let calendar = [];
      for (var k = 0; k < week.length; k++){
          calendar.push(<span key={"a" + k} className={k === 0 ? 'sunday' : ''}>{week[k]}</span>);
      }
      var count = 0;
      var startDayOfWeek = new Date(year, month, 1).getDay();
      var endDate = new Date(year, month + 1, 0).getDate();
      var lastMonthEndDate = new Date(year, month, 0).getDate();
      var row = Math.ceil((startDayOfWeek + endDate) / week.length);
      // 1行ずつ設定
      let yyy = [];
      for (var i = 0; i < row; i++) {
        let calendar2 = [];
          for (var j = 0; j < week.length; j++) {
             
              if (i === 0 && j < startDayOfWeek) {
                  // 1行目で1日まで先月の日付を設定
                  calendar2.push(<span className='disabled' key={"a" + i + j}>{lastMonthEndDate - startDayOfWeek + j + 1}</span>);
              } else if (count >= endDate) {
                  // 最終行で最終日以降、翌月の日付を設定
                  count++;
                  calendar2.push(<span className='disabled' key={"a" + i + j}>{count - endDate}</span>);
              } else {
                  // 当月の日付を曜日に照らし合わせて設定
                  count++;

                  let bookDate = year + (('0' + String(month + 1)).slice(-2)) + (('0' + String(count)).slice(-2));

                  let result = checkDayOffAry(dayOnOffAry, bookDate);

                  if(result === 'all'){
                    calendar2.push(<span key={"a" + i + j}>{count}<br /><span className='spDayOff'>臨時休診</span></span>);
                  }else if(result === 'tc'){
                    calendar2.push(<span key={"a" + i + j}>{count}<br /><span className='spDayOff'>先生休診</span></span>);
                  }else{
                    if(props.propsState.aryDayOff[j] === true){
                      calendar2.push(<span key={"a" + i + j}>{count}<br /><span className='spDayOff'>休診日</span></span>);
                    }else{

                      let eachUsedTime = daysUsedTime[bookDate] === undefined ? 0 : (daysUsedTime[bookDate]) /10;

                      let middleSpan = (class2)=>{

                        let middleSpan2 = eachUsedTime >= weekTimesAry[j] ? 
                          <span className={class2} key={"a" + i + j}>
                            <span className='clDayNum'>{count}</span>
                            <span className='clDaySign'>×</span>
                          </span>
                          :
                          <span className={class2} key={"a" + i + j} onClick={()=> setDate3(bookDate,mon)}>
                            <span className='clDayNum'>{count}</span>
                            <span className='clDaySign'>{eachUsedTime > (weekTimesAry[j] /2) ? '△' : '〇'}</span>
                          </span>;

                          return middleSpan2
                        }

                      let mon = j;
                      if(whichMonth === 'thisMonth'){
                        if(year === today.getFullYear()
                          && month === (today.getMonth())
                          && count === today.getDate()){
                            calendar2.push(middleSpan('today'));
                        } else if(year === today.getFullYear()
                          && month === (today.getMonth())
                          && count >= today.getDate()
                          && count <= today.getDate() + acceptBook){
                            calendar2.push(middleSpan('inWeek'));
                        } else {
                            calendar2.push(<span key={"a" + i + j}>{count}</span>);
                        }
                      }else{
                        // console.log("vvvvvv");
  
                        let countDay = new Date(year, month, count);
                        if(today < countDay && countDay < limitDay){
                            calendar2.push(middleSpan('inWeek'));
                        } else {
                            calendar2.push(<span key={"a" + i + j}>{count}</span>);
                        }
                      }
                    }
                  }
              }
          }
          yyy.push(<div className='cdRow1' key={"b" + i}>{calendar2}</div>);
      }

      return (
        <div id="calendar2">
          <div className="clNextBtn">
            <button className="prev2" onClick={prev}>＜<br />前の月</button>
            <span className='mainCdP2'>{year}年<span>{month + 1}月</span></span>
            <button className="next2" onClick={next}>＞<br />次の月</button>
          </div>
          
          <div className='mainCdTopDate'>
            {calendar}
          </div>
          {yyy}
        </div>
      );
  }
  useEffect(() => {
    showProcess(showDate3);
    // console.log(props.state)
  }, []);
  const backBtn =()=>{
    if(props.state.pageSkip[2]){
      if(props.state.pageSkip[1]){
        if(props.state.pageSkip[0]){
          props.handleGoBook('top')
        }else{
          props.backPage('History',props.state.btnNum - 1)
        }
      }else{
        props.backPage('Details',props.state.btnNum - 1)
      }
    }else{
      props.backPage('Teacher',props.state.btnNum - 1)
    }
  }

  return(
    <div>
      <div className='bookFrame1 wide'>
        <p className="formTopQ" onClick={()=> props.setDate()}>ご希望の受診日を選択してください</p>
        <div>
          {calender5}
        </div>
        <button className='backBtn' onClick={()=>backBtn()}>前に戻る</button>
      </div>
    </div>
  );
}
function Teacher(props){
  const teacherAry = props.propsState.allField.teacher2;

  const setTeacherBtn = ()=>{
    let freeTc = {id: 'free', name: 'free'}
    let ary = [];
    ary.push(
      <button key={'teacherFree'} className='formBtn1 gray' onClick={()=> props.setTeacher(freeTc, 'フリー', props.state.btnNum +1)}>指名なし</button>
    )
    for(let i = 0; i < teacherAry.length; i++){
      let teacher = teacherAry[i];

      if(teacher['detailsNG'].includes(props.state.details)){
        // console.log('NG');
      }else{
        ary.push(
          <button key={'teacher' + i} className='formBtn1 gray' onClick={()=> props.setTeacher(teacher, '指名', props.state.btnNum +1)}>{teacher.name}</button>
        )
      }
    }
    return ary;
  }

  useEffect(() => {
    if(props.state.pageSkip[2]){
      props.setTeacher(teacherAry[0], '指名', props.state.btnNum)
    }
  }, [])
  const backBtn =()=>{
    if(props.state.pageSkip[1]){
      if(props.state.pageSkip[0]){
        props.handleGoBook('top')
      }else{
        props.backPage('History',props.state.btnNum - 1)
      }
    }else{
      props.backPage('Details',props.state.btnNum - 1)
    }
  }
  return (
    <div>
      {props.state.pageSkip[2] ?
          ''
        :
          <div className='bookFrame1'>
            <p className="formTopQ">獣医師の指名はございますか？</p>
            <div className='bookFrame2'>
              {setTeacherBtn()}
            </div>
            <button className='backBtn' onClick={()=>backBtn()}>前に戻る</button>
          </div>
      }
    </div>
  );
}
function Details(props){
  const detailsTypeAry = props.propsState.allField.detailsType;
  const history = props.history === '初診' ? 'first':'second';

  const setDetailsBtn = ()=>{
    let ary = [];
    
    for(let i = 0; i < detailsTypeAry.length; i++){
      let type = detailsTypeAry[i].type;
      let time = detailsTypeAry[i][history];
      ary.push(
        <button key={'details' + i} className='formBtn1 gray' onClick={()=> props.setDetails(type,time, props.state.btnNum +1)}>{type}</button>
      )
    }
    return ary;
  }
  useEffect(() => {
    if(props.state.pageSkip[1]){
      props.setDetails(detailsTypeAry[0].type, detailsTypeAry[0][history], props.state.btnNum)
    }
  }, [])
  const backBtn =()=>{
    if(props.state.pageSkip[0]){
      props.handleGoBook('top')
    }else{
      props.backPage('History',props.state.btnNum - 1)
    }
  }

  return(
    <div>
      <div className='bookFrame1'>
        <p className="formTopQ">受診内容を教えてください。</p>
        <div className='bookFrame2'>
          {setDetailsBtn()}
        </div>
        <button className='backBtn' onClick={()=>backBtn()}>前に戻る</button>
      </div>
    </div>
  )
}
function History(props){

  useEffect(() => {
    if(props.state.pageSkip[0]){
      props.setHistory('再診', props.state.btnNum)
    }
  }, [])

  return (
    <div className='bookFrame1'>
      <p className="formTopQ">当院を受診された事はありますか？</p>

      <p>当院の受診が初めての方はこちら</p>
      <button className='formBtn1 blue' onClick={()=> props.setHistory('初診', props.state.btnNum +1)}>初診</button>
      <p>当院に診察されたことがある方はこちら</p>
      <button className='formBtn1 red' onClick={()=> props.setHistory('再診', props.state.btnNum +1)}>再診</button>
      <button className='backBtn' onClick={()=>props.handleGoBook('top')}>前に戻る</button>
    </div>
  );
}
class Book extends React.Component{
  constructor(props) {
    super(props);
    this.state = {
      login: false,
      customerId: '',
      page: '',
      bookList: {},
      btnNum: 1,
      btnNumTotal: 6,
      bookDayMon: '',
      history: '',
      details: '',
      detailsTime: 10,
      teacher: '',
      teacherName: '',
      teacherFixed: '',
      bookDate: '',
      bookTime: '',
      petName: '',
      petName2: '',
      petType: '',
      name: '',
      name2: '',
      cardNum: '',
      telNum: '',
      email: '',
      other: '',
      line: false,
      pageSkip: []
    };
    this.setHistory = this.setHistory.bind(this);
    this.setDetails = this.setDetails.bind(this);
    this.setTeacher = this.setTeacher.bind(this);
    this.setDate = this.setDate.bind(this);
    this.setDate2 = this.setDate2.bind(this);
    this.setPetName = this.setPetName.bind(this);
    this.setGuestName = this.setGuestName.bind(this);
    this.setConfirm = this.setConfirm.bind(this);
    this.backPage = this.backPage.bind(this);
    this.backSetDate2 = this.backSetDate2.bind(this);
    this.loginSuccess = this.loginSuccess.bind(this);
    this.setLoginUser = this.setLoginUser.bind(this);
    this.setBookList = this.setBookList.bind(this);
    this.checkPageSkip = this.checkPageSkip.bind(this);
  }
  setBookList(bookList){
    this.setState({bookList: bookList});
  }
  setHistory(history, btn){
    this.setState({history: history, page: 'Details', btnNum: btn});
  }
  setDetails(details,time, btn){
    this.setState({details: details, detailsTime: time, page: 'Teacher', btnNum: btn});
  }
  setTeacher(teacher, assign, btn){
    this.setState({teacher: teacher.id, teacherName: teacher.name, teacherFixed: assign, page: 'SetDate', btnNum: btn});
  }
  setDate(bookDate,j){
    const aryDate = ['sun','mon','tue','wed','thu','fri','sat','pub'];
    this.setState({bookDate: bookDate,page: 'SetDate2', bookDayMon: aryDate[j]});
  }
  setDate2(bookTime,teacher){
    if(teacher === 'notFree'){
      this.setState({bookTime: bookTime, page: 'PetName', btnNum: this.state.btnNum + 1});
    }else{
      this.setState({bookTime: bookTime, page: 'PetName', btnNum: this.state.btnNum + 1, teacher: teacher.id, teacherName: teacher.name});
    }
  }
  setPetName(petName, petName2, petType,cardNum,other){
    this.setState({petName: petName, petName2: petName2, petType:petType, cardNum: cardNum, other: other, page: 'GuestName'});
  }
  setGuestName(name, name2, telNum,email,line){
    this.setState({name: name, name2: name2, telNum: telNum, email: email, line: line, page: 'Confirm', btnNum: this.state.btnNum + 1});
  }
  backPage(page, num){
    this.setState({page: page, btnNum: num});
  }
  backSetDate2(page, num){
    if(this.state.teacherFixed === '指名'){
      this.setState({page: page, btnNum: num});
    }else{
      this.setState({page: page, btnNum: num, teacher: 'free', teacherName: 'free'});
    }

    this.setState({page: page, btnNum: num});
  }
  async loginSuccess(page, num, userId){
    try{
      const docRef2 = doc(db, "ahCustomerListsWT", this.props.state.id, "ahCustomerListsWT2",userId);
      const docRef = await getDoc(docRef2);
      if(docRef.exists()){
        const userInfo = docRef.data();

        this.setState({
          page: page,
          btnNum: num,
          petName: userInfo.petName,
          petName2: userInfo.petName2,
          petType: userInfo.petType,
          name: userInfo.name,
          name2: userInfo.name2,
          cardNum: userInfo.cardNum,
          telNum: userInfo.telNum,
          email: userInfo.email,
          login: true,
          customerId: userId
        });
      }
    }catch(e){
      console.log(e);
    }
    maskClose();
  }
  async setConfirm(){
    maskOpen();
    console.log(this.state.bookDate);
    
    try{
      let thisDate = this.state.bookDate;
      let thisTime = this.state.bookTime;
      let time2 = thisTime.slice(0,2) + thisTime.slice(3,5);
      let bookId = thisDate + time2 + new Date().getTime().toString(16) + Math.floor(1000 * Math.random()).toString(16);
      // console.log(bookId);

      let thisBook = {
        history: this.state.history,
        details: this.state.details,
        detailsTime: this.state.detailsTime,
        teacher: this.state.teacher,
        teacherName: this.state.teacherName,
        teacherFixed: this.state.teacherFixed,
        bookDate: this.state.bookDate,
        bookTime: this.state.bookTime,
        petName: this.state.petName,
        petName2: this.state.petName2,
        petType: this.state.petType,
        name: this.state.name,
        name2: this.state.name2,
        cardNum: this.state.cardNum,
        telNum: this.state.telNum,
        email: this.state.email,
        other: this.state.other,
        state: '予約',
        from: 'WEB',
        line: this.state.line,
        bookId: bookId,
        customerId: this.state.customerId,
        createdAt: serverTimestamp()
      }

      let ref1 = this.state.bookDate.slice(0,6);
      const docRef1 = doc(db, "waitingList", this.props.state.id, ref1,this.state.bookDate);
      const docSnap = await getDoc(docRef1);
      if(docSnap.exists()){

        let bookListId = "bookList." + bookId
        await updateDoc(docRef1,{
          [bookListId]: thisBook
        })

        console.log('New Book2!!');
        this.setState({page: 'BookDone'});

      }else{

        let lists = { [bookId]: 
          { history: this.state.history,
            details: this.state.details,
            detailsTime: this.state.detailsTime,
            teacher: this.state.teacher,
            teacherName: this.state.teacherName,
            teacherFixed: this.state.teacherFixed,
            bookDate: this.state.bookDate,
            bookTime: this.state.bookTime,
            petName: this.state.petName,
            petName2: this.state.petName2,
            petType: this.state.petType,
            name: this.state.name,
            name2: this.state.name2,
            cardNum: this.state.cardNum,
            telNum: this.state.telNum,
            email: this.state.email,
            other: this.state.other,
            state: '予約',
            from: 'WEB',
            line: this.state.line,
            bookId: bookId,
            customerId: this.state.customerId,
            createdAt: serverTimestamp()
          }}

        await setDoc(docRef1,{
          bookList: lists
        })
        
        console.log('New Book3!!');
      }

      const docRef1Back = await getDoc(docRef1);
      let timeStamp3 = docRef1Back.data().bookList[bookId]["createdAt"];

      const time = (date)=> {
        let jpTime = new Date(date.toDate().getTime() + ((new Date().getTimezoneOffset() + (9 * 60)) * 60 * 1000));
        let year = jpTime.getFullYear();
        let month = (jpTime.getMonth()) + 1;
        let date2 = jpTime.getDate();
        let hour = jpTime.getHours();
        let min = ('0' + jpTime.getMinutes()).slice(-2);
        return year + '年' + month + '月' + date2 + '日' + hour + ':' + min;
      }
      
      thisBook["createdAt"] = time(timeStamp3)
      // console.log(thisBook)
      if(this.state.login){
        try{
          const docRef2 = doc(db, "ahCustomerListsWT", this.props.state.id, "ahCustomerListsWT2", this.state.customerId);
          const docSnap2 = await getDoc(docRef2);
          let historyAry = docSnap2.data().bookHistory
          
          historyAry.push(thisBook);
          await updateDoc(docRef2,{
            'bookHistory': historyAry
          });
          console.log('bookHistory done');
  
        }catch(e){
          console.log(e);
        }
      }

      const docRefWL = doc(db, "waitingList", this.props.state.id);
      const docSnapWL = await getDoc(docRefWL);
      if (docSnapWL.exists()) {
        let latestAry = docSnapWL.data().latestBook;

        let latestNum = this.props.state.allField.setting.latestNum

        latestAry.unshift(thisBook)
        if(latestAry.length > latestNum ){
          latestAry.pop()
          if(latestAry.length > latestNum){latestAry.pop()}
        }
        await updateDoc(docRefWL,{
          latestBook: latestAry
        })
      }

      if(this.state.email !== ''){

        let bookDate3 = (this.state.bookDate).slice(0,4) + '年' + (this.state.bookDate).slice(4,6) + '月' + (this.state.bookDate).slice(-2) + '日';

        try{
          let tc = this.state.teacherFixed === 'フリー' ? '指名なし' : this.state.teacherName;

          const docRefMail = await addDoc(collection(db, 'mail'),{
            to: this.state.email,
            from: 'info@wan-touch.com',
            message: {
              subject: '予約を受付いたしました。',
              text: this.state.name + this.state.name2 + '様\n\n'
              + '以下の内容にてご予約が完了いたしました。'
              + '\n\n予約日時: ' + bookDate3 + ' ' + this.state.bookTime
              + '\n\n■予約内容'
              + '\n獣医師: ' + tc
              + '\n診察内容: ' + this.state.details
              + '\n備考: ' + this.state.other
              + '\n\n■受診するペット'
              + '\n名前: ' + this.state.petName  + this.state.petName2
              + '\n種類: ' + this.state.petType
              + '\n診察券番号: ' + this.state.cardNum
              + '\n\n■飼い主様情報'
              + '\n名前: ' + this.state.name + this.state.name2
              + '\n電話番号: ' + this.state.telNum
              + '\nメールアドレス: ' + this.state.email
              + '\n\n\n' + this.props.state.allField.basic.name
              + '\n\n※「wan-touch時間予約メール通知サービス」は、送信専用アドレスで送信しております。\nこのメールに返信されても受信できません。',
            },
          });
        }catch(e){
          console.log(e)
        }
      }
      
      this.setState({page: 'BookDone', btnNum: 5});

    }catch(e){
      console.log(e);
    }
    maskClose();
  }
  setLoginUser(){
    if(this.props.state.loginUser !== ''){
      this.setState({
        petName:  this.props.state.loginUser.petName,
        petName2:  this.props.state.loginUser.petName2,
        petType:  this.props.state.loginUser.petType,
        name: this.props.state.loginUser.name,
        name2: this.props.state.loginUser.name2,
        cardNum:  this.props.state.loginUser.cardNum,
        telNum:  this.props.state.loginUser.telNum,
        email:  this.props.state.loginUser.email,
        login: true,
        customerId:  this.props.state.loginUser.customerId
      });
    }
  }
  checkPageSkip(){
    let ary = []
    let num = 0
    ary.push(this.props.state.loginUser !== '' ? true : false)
    ary.push(this.props.state.allField.detailsType.length === 1 ? true : false)
    ary.push(this.props.state.allField.teacher2.length === 1 ? true : false)
    
    ary.forEach((ary1) => {
      if(ary1){num += 1}
    })
    this.setState({ pageSkip: ary, btnNumTotal: this.state.btnNumTotal - num})
    this.setState({ page: 'History'})
  }
  
  componentDidMount = () => {
    this.setLoginUser(this.props.state.loginUser);
    this.checkPageSkip();
  }

  render(){
    let form;
    if(this.state.page === 'History'){
      form = <History setHistory={this.setHistory} handleGoBook={this.props.handleGoBook} state={this.state}/>
    }else if(this.state.page === 'Details'){
      form = <Details setDetails={this.setDetails} propsState={this.props.state} history={this.state.history} backPage={this.backPage} state={this.state} handleGoBook={this.props.handleGoBook}/>
    }else if(this.state.page === 'Teacher'){
      form = <Teacher setTeacher={this.setTeacher} propsState={this.props.state} state={this.state} backPage={this.backPage} handleGoBook={this.props.handleGoBook}/>
    }else if(this.state.page === 'SetDate'){
      form = <SetDate setDate={this.setDate} propsState={this.props.state} state={this.state} backPage={this.backPage} setBookList={this.setBookList} handleGoBook={this.props.handleGoBook}/>
    }else if(this.state.page === 'SetDate2'){
      form = <SetDate2 setDate2={this.setDate2} propsState={this.props.state} state={this.state} backPage={this.backPage} />
    }else if(this.state.page === 'PetName'){
      form = <PetName setPetName={this.setPetName} propsState={this.props.state} state={this.state} backSetDate2={this.backSetDate2} backPage={this.backPage} />
    }else if(this.state.page === 'GuestName'){
      form = <GuestName setGuestName={this.setGuestName} backPage={this.backPage} state={this.state} />
    }else if(this.state.page === 'Other'){
      // form = <Other setOther={this.setOther} backPage={this.backPage} state={this.state} />
    }else if(this.state.page === 'Confirm'){
      form = <Confirm setConfirm={this.setConfirm} state={this.state} backPage={this.backPage} />
    }else if(this.state.page === 'BookDone'){
      form = <BookDone setConfirm={this.setConfirm} state={this.state} propsState={this.props.state}/>
    }else if(this.state.page === 'Login'){
      form = <Login loginSuccess={this.loginSuccess} backPage={this.backPage} />
    }else{
      form = ''
    }

    let btnFive = []
    for(let i = 1; i < this.state.btnNumTotal; i++){
      let k = i
      btnFive.push(
        <li key={i + '5btn'} className={this.state.btnNum >= k ? 'now' : ''}>{i}</li>
      )
    }
    
    return(
      <div className="body_gray">
        {ScrollToTop()}
        <div className="container2" id="container">
          <header>
            <p className="appName"></p>
            <p className="top_page">{this.props.state.allField.basic.name}<br />予約フォーム</p>
            {this.state.btnNum === 6 ? '' : 
              <ul className='headBtn5'>
                {btnFive}
                {/* <li className={this.state.btnNum >= 1 ? 'now' : ''}>1</li>
                <li className={this.state.btnNum >= 2 ? 'now' : ''}>2</li>
                <li className={this.state.btnNum >= 3 ? 'now' : ''}>3</li>
                <li className={this.state.btnNum >= 4 ? 'now' : ''}>4</li>
                <li className={this.state.btnNum >= 5 ? 'now' : ''}>5</li> */}
              </ul>
            }
          </header>
          {this.props.state.loginUser === '' ? '' : <p className='guestName'>【{this.props.state.loginUser.name}様】</p>}
          
          {form}
          <div className='topMiddle'>
            <a href={this.props.state.allField.basic.webURL} rel='nofollow'><button className='topUnderBtn hp'>公式サイト</button></a>
            <button className='topUnderBtn tell'>{this.props.state.allField.basic.tell}</button>
          </div>
          <p className='topFootCopy'>Copyright © 2024 wantouch All rights reserved.</p>
        </div>
        
      </div>
    )
  }
}
class Top extends React.Component{
  constructor(props) {
    super(props);
    
    this.bookBtn = this.bookBtn.bind(this);
    this.myPageBtn = this.myPageBtn.bind(this);
    this.logoutWT = this.logoutWT.bind(this);
  }
  
  bookBtn(){
    return(
      <div className='topBookBtn'>
        <button className="top_btn2 book" onClick={()=>this.props.handleGoBook('book')}>予約する</button>
      </div>
    );
  }
  myPageBtn(){
    return(
      <div>
        <p className="p3">予約済みの方はこちら</p>
        <button className="top_btn2 toMP booked">マイページへ</button>
      </div>
    );
  }
  async logoutWT(){
    const auth = getAuth();
    await signOut(auth).then(() => {
        console.log("Sign-out")
        this.props.logoutUser();
      })
      .catch(err => {
        console.log(err.message);
      })
  };
  render(){
    return(
      <div className="body_gray">
          {/* {ScrollToTop()} */}
          <div className="container2">
            <header>
              <p className="appName"></p>
              <p className="top_page">{this.props.state.allField.basic.name}<br />WEB受付ページ</p>
            </header>
            
            <div className='topMiddle'>
              <p className="newsLabel">当院からのお知らせ</p>
              <div className="news">
                {this.props.state.allField.setting.news}
              </div>
            </div>

            <div className='topMiddle'>
              {this.props.state.loginUser === '' ? '' : <p>{this.props.state.loginUser.name}様<br />おかえりなさい！！</p>}
    
              {this.bookBtn()}
              {this.props.state.loginUser === '' ? '' : <button className='topLogOut' onClick={()=>this.logoutWT()}>ログアウト</button>}
            </div>

            <div className='topMiddle'>
              <button className='topUnderBtn hp'><a href={this.props.state.allField.basic.webURL} rel='nofollow'>公式サイト</a></button>
              <button className='topUnderBtn tell'>{this.props.state.allField.basic.tell}</button>
            </div>
            <p className='topFootCopy'>Copyright © 2024 wantouch All rights reserved.</p>
            
          </div>
        </div>
    );
  }
}
class App extends React.Component{
  constructor(props) {
    super(props);

    this.state = {
      section: '',
      id: '',
      aryDayOff: [],
      allField: [[]],
      loginUser: ''
    };
    this.getData = this.getData.bind(this);
    this.handleGoBook = this.handleGoBook.bind(this);
    this.checkLoginUser = this.checkLoginUser.bind(this);
    this.logoutUser = this.logoutUser.bind(this);
  }
  getData = async () => {
    let url = new URL(window.location.href);
    let params = url.searchParams;
    let urlId = params.get('id') + '168';
    // let urlId = "hospital168";

    const docRef2 = doc(db, "ahBasicInfo", urlId);
    const docSnap2 = await getDoc(docRef2);
    if (docSnap2.exists()) {

      const aryDate = ['sun','mon','tue','wed','thu','fri','sat','pub'];
      let dayoffAry = [];
      aryDate.forEach((dayoff) => {
        let dayX = docSnap2.data()[dayoff];
        dayoffAry.push(dayX.dayoff);
      });
      let all = docSnap2.data();

      this.setState({section: 'top', aryDayOff: dayoffAry, allField: all, id: urlId });
    }else{
      const topLoading = document.getElementById('topLoading')
      topLoading.classList.add('error');
      topLoading.innerHTML = '※ページを読み込めません。（URLをお確かめください）'
    }
  }
  handleGoBook(page){
    this.setState({section: page});
  }
  async checkLoginUser(){

    const auth2 = getAuth();
    onAuthStateChanged(auth2, async(user) => {
      if (user) {
        
        try{
          let url = new URL(window.location.href);
          let params = url.searchParams;
          let urlId = params.get('id') + '168';
          const docRef2 = doc(db, "ahCustomerListsWT", urlId, "ahCustomerListsWT2", user.uid);
          const docSnap2 = await getDoc(docRef2);
          if (docSnap2.exists()){

            let user2 = docSnap2.data();
            this.setState({loginUser: user2});
            // console.log('user2');
          }
          maskClose();
        }catch(e){
          maskClose();
          console.log(e);
        }
        
      } else {
        console.log('no login');
        maskClose();
      }
    });
  }
  logoutUser(){
    this.setState({loginUser: ''});
  }
  componentDidMount = async () => {
    maskOpen();
    await this.getData();
    // await this.checkLoginUser();
    maskClose();
  }
  render(){
    let section;
    if(this.state.section === 'top'){
      section = <Top handleGoBook={this.handleGoBook} state={this.state} logoutUser={this.logoutUser} />
    }else if(this.state.section === 'book'){
      section = <Book state={this.state} handleGoBook={this.handleGoBook} />
    }else{
      section = <p className='loading' id='topLoading'>loading...</p>
    }
    return(
      <div className="App">
        <div>
          {section}
        </div>
        <div id='mask' className=''></div>
      </div>
    );
  }
}
function maskOpen(){
  const mask = document.getElementById('mask');
  mask.classList.add('show');
}
function maskClose(){
  const mask = document.getElementById('mask');
  mask.classList.remove('show');
}
function ScrollToTop(){
  window.scrollTo(0, 0);
}

export default App;